window['openSimpleIframeModalDialog'] = function (modalUrl, modalClass) {
    createPopupDialog();

    var $targetModal = $('#popupDialog');

    var additionalClasses = 'modal-simple-iframe ' + modalClass;
    $targetModal.addClass(additionalClasses);

    var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');
    $targetModal.modal({ backdrop: 'static', keyboard: false, show: true });
    var targetIframe = $targetModal.find('iframe');
    if (targetIframe) {
        $targetModal.find('iframe').remove().attr('src', '');
    }
    var iframe = $('<iframe id=\"selector\" frameborder=\"0\">');

    iframe.attr('src', modalUrl);
    iframe.on("load", function () {
        stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
        $(this).show();
    });
    $('.modal-body', $targetModal).append(iframe);
    $targetModal.modal();
    $targetModal.find('.modal-footer').remove();
    window.closeModal = function () { $targetModal.modal('hide'); };
    $targetModal.on('hidden.bs.modal', function () { $targetModal.removeClass(additionalClasses); });
};

(function ($) {
    openAudienceModalDialog = function (redirecturl, modalUrl, modalClass) {
        createPopupDialog();

        var $targetModal = $('#popupDialog');
        if (modalClass) {
            $targetModal.addClass(modalClass);
        } else {
            $targetModal.addClass('ahp-selector-modal');
        }

        var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');
        $targetModal.modal({ backdrop: 'static', keyboard: false, show: true });
        var targetIframe = $targetModal.find('iframe');
        if (targetIframe) {
            $targetModal.find('iframe').remove().attr('src', '');
        }
        var iframe = $('<iframe id=\"selector\" frameborder=\"0\">');
        var iframeUrl = ' /audience-selector-modal/';
        if (modalUrl) {
            iframeUrl = modalUrl;
        }
        if (redirecturl !== undefined && redirecturl !== '') {
            if (iframeUrl.match(/\?./)) {
                iframeUrl = iframeUrl + "&returnurl=" + redirecturl;
            } else {
                iframeUrl = iframeUrl + "?returnurl=" + redirecturl;
            }
        }
        iframe.attr('src', iframeUrl);
        iframe.on("load", function () {
            stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
            $(this).show();
        });
        $('.modal-body', $targetModal).append(iframe);
        $targetModal.modal();
        $targetModal.find('.modal-header').remove();
        $targetModal.find('.modal-footer').remove();
        window.closeModal = function () { $targetModal.modal('hide'); };
    };

    openGenericModalDialog = function (redirecturl, modalUrl, modalClass) {
        createPopupDialog();

        var $targetModal = $('#popupDialog');
        if (modalClass) {
            $targetModal.addClass(modalClass);
        } else {
            $targetModal.addClass('ahp-selector-modal');
        }

        var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');
        $targetModal.modal({ backdrop: 'static', keyboard: false, show: true });
        var targetIframe = $targetModal.find('iframe');
        if (targetIframe) {
            $targetModal.find('iframe').remove().attr('src', '');
        }
        var iframe = $('<iframe id=\"selector\" frameborder=\"0\">');
        var iframeUrl = ' /audience-selector-modal/';
        if (modalUrl) {
            iframeUrl = modalUrl;
        }
        if (redirecturl !== undefined && redirecturl !== '') {
            if (iframeUrl.match(/\?./)) {
                iframeUrl = iframeUrl + "&returnurl=" + redirecturl;
            } else {
                iframeUrl = iframeUrl + "?returnurl=" + redirecturl;
            }
        }
        iframe.attr('src', iframeUrl);
        iframe.on("load",function () {
            stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
            $(this).show();
        });
        $('.modal-body', $targetModal).append(iframe);
        $targetModal.modal();
        $targetModal.find('.modal-header').remove();
        $targetModal.find('.modal-footer').remove();
        window.closeModal = function () { $targetModal.modal('hide'); };
    };

    createPopupDialog = function (popupClass) {
        if (popupClass === undefined) {
            popupClass = "";
        }

        var template = "<div id='popupDialog' class='modal fade" + popupClass + "' tabindex='-1' role='dialog'>" +
                       "  <div class='modal-dialog' role='document'>" +
                       "    <div class='modal-content'>" +
                       "      <div class='modal-header'>" +
                       "        <button type='button' class='close' data-dismiss='modal' aria-label='Close'><span aria-hidden='true'>&times;</span></button>" +
                       "      </div>" +
                       "      <div class='modal-body'>" +
                       "        <div id='modal-spinner'>" +
                       "        </div>" +
                       "      </div>" +
                       "      <div class='modal-footer disclaimerpop'></div>" +
                       "    </div>" +
                       "  </div>" +
                       "</div>";

        if ($("#popupDialog").length === 0) {
            $("body").append(template);
        }

        $(".modal").on('hidden.bs.modal', function () {
            $(e.target).data('modal', null);
            $('.modal').remove();
            $('.modal-backdrop').remove();
            $('body').removeClass("modal-open");
        });
    };

    $(document).ready(function () {

        function getModalDialogFromLink(selector) {
            return $(selector.data('target'));
        }

        function setSpinner(event) {
            $('.modal-body', $(this)).html('<div id="modal-spinner"></div>');
        }

        function generateModalButton(href, text, cssClass) {
            var button = $('<a />');
            button
            .attr({
                class: cssClass,
                href: href
            })
            .html('<span>' + text + '</span>');

            return button;
        }

        function getParameterByName(name, url) {
            if (!url)
                url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
            results = regex.exec(url);
            if (!results)
                return null;
            if (!results[2])
                return '';
            return encodeURI(decodeURIComponent(results[2].replace(/\+/g, " ")));
        }

        function getParameterByNameDefault(name, url, defaultValue) {
            var paramValue = getParameterByName(name, url);
            if (paramValue === null) {
                return defaultValue;
            }

            return paramValue;
        }

        function clickIframeModalLink(event) {
            event.preventDefault();
            event.stopPropagation();

            var popupClass = "";

            if ($(this).data("isPrintDialog") === true) {
                popupClass = " print-pdf-dialog";
            }

            createPopupDialog(popupClass);

            var handler = $(this);
            var targetModal = getModalDialogFromLink(handler);
            var remote = handler.attr('href');

            var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');

            var enforceMinSize = getParameterByNameDefault('enforceminsize', remote, "false") === "true";
            var width = getParameterByNameDefault('width', remote, 672);
            var height = getParameterByNameDefault('height', remote, 460);

            if (handler[0].hasAttribute("data-width")) {
                width = handler.data("width");
            }
            if (handler[0].hasAttribute("data-height")) {
                height = handler.data("height");
            }

            //Enforce min width and height
            if (enforceMinSize) {
                if (width < 672) { width = 672; }
                if (height < 460) { height = 460; }
            }

            var windowHeight = $(window).height();
            if ((parseInt(height, 10) + 100) > windowHeight) {
                height = windowHeight - 150;
            }

            var footer = $('.modal-footer', targetModal);
            footer.html('');

            var showButtons = getParameterByNameDefault('button', remote, null) === "yes";
            if (showButtons) {
                var acceptBtnLink = getParameterByNameDefault('url', remote, null);
                if (acceptBtnLink !== null) {
                    if (acceptBtnLink.indexOf("&country=") === -1 && acceptBtnLink.indexOf("?country=") === -1) {
                        var country = getParameterByNameDefault('country', remote, null);
                        if (country !== null) { acceptBtnLink = acceptBtnLink + "?country=" + country; }
                    }

                    var acceptBtn = generateModalButton(acceptBtnLink, 'I Agree', 'agree-btn');
                    acceptBtn.on("click", function () { targetModal.modal("hide"); });
                    acceptBtn.attr("target", "_blank");
                    footer.append(acceptBtn);
                }

                var declineBtnLink = getParameterByNameDefault('declineurl', remote, ".");
                if (declineBtnLink !== null) {
                    if (declineBtnLink !== ".") {
                        var country = getParameterByNameDefault('country', remote, '');
                        if (country !== '') { declineBtnLink = declineBtnLink + "?country=" + country; }
                    }

                    var declineBtn = generateModalButton(declineBtnLink, 'I Decline', 'decline-btn');
                    declineBtn.attr("data-dismiss", "modal");
                    footer.append(declineBtn);
                }
            } else {
                var isShowCancelButton = handler[0].hasAttribute("data-show-cancel-button") ? handler.data("showCancelButton") === "true" : true;
                if (isShowCancelButton) {
                    var cancelBtn = generateModalButton('#', 'Close', 'close-btn');
                    cancelBtn.attr("data-dismiss", "modal");
                    footer.append(cancelBtn);
                }
            }

            var iframe = $('<iframe width="100%" height="100%">');
            iframe.attr('src', remote);
            iframe.on('load', function () {
                stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
                $(this).show();
            });

            $('.modal-dialog', targetModal).css('width', width + 'px');
            $('.modal-body', targetModal).css('height',  height + 'px')
                                         .css('margin-bottom', '6px')
                                         .append(iframe);

            footer.show();
            targetModal.modal();
            targetModal.on('hidden.bs.modal', setSpinner);
            window.closeModal = function () { targetModal.modal('hide'); };
        }

        $("[data-toggle=modal][data-target='#popupDialog']").click(clickIframeModalLink);

        $('.ddlPremiumDiscount').on('change', function () {
            var spinner = doSpinnerByLoadingId(null, null, 'modal-spinner');

            createPopupDialog();

            var targetModal = $('#popupDialog');
            var targetIframe = targetModal.find('iframe');
            if (targetIframe) {
                targetModal.find('iframe').remove().attr('src', '');
            }
                
            if (this.value.indexOf('Select') < 0) {
                var iframe = $('<iframe class="discountframe" width="720" height="430">');
                iframe.attr('src', this.value);
                iframe.on('load', function () {
                    stopSpinnerByLoadingId(spinner, null, 'modal-spinner');
                    $(this).show();
                });
                $('.modal-body', targetModal).css('margin-bottom', '6px')
                    .append(iframe);
                $('.modal-content', targetModal).css('margin-top', '25%');
                $('.modal-footer', targetModal).hide();
                $('#popupDialog').modal();
                $('#popupDialog').on('hidden.bs.modal', setSpinner);
				$('.ddlPremiumDiscount').prop('selectedIndex',0);
            }
        });

        var $element = $('.share-popover');
        if ($element[0]) {
            $element.popover({
                html: true,
                placement: 'bottom',
                title: '<span class="text-info"><strong>Share</strong></span>' +
                    '<button type="button" id="close" class="close">&times;</button>',
                container: $('body'),
                content: $('#content').html()
            }).click(function (e) {
                e.preventDefault();
                $('.popover').css('left', $(this).offset().left - 172 + 'px');
                $('.popover .arrow').css('display', 'none');
            });

            $element.on('shown.bs.popover', function () {
                var popover = $element.data('bs.popover');
                if (typeof popover !== "undefined") {
                    var $tip = popover.tip();
                    zindex = $tip.css('z-index');
                    $tip.find('.close').bind('click', function () {
                        $element.click();
                    });
                }
            });
        }

        $('#open-ahp-modal').click(function (e) {
            openAudienceModalDialog('', '/profile/reselect/', '');
        });

        $('#open-ahp-modal-for-image').click(function (e) {
            openAudienceModalDialog('', '/profile/reselect-map/', '');
        });

        $('#open-ahp-modal-microsites,#open-ahp-modal-mobile').click(function (e) {
            openAudienceModalDialog('', $(this).data('url'), '');
            $('body').removeAttr('style');
        });

        getHtml = function (dataUrl) {
            return $.ajax({
                type: "GET",
                url: dataUrl,
                cache: false
            });
        };

        var dataUrl = $('#admin-link-url').val();
        if (dataUrl) {
            var returnResponse = getHtml(dataUrl);
            returnResponse.success(function (response) {
                if (response !== '') {
                    $('#admin-link-container').html(response);
                }
            });
        }

        var random = Math.floor(Math.random() * $('.promo-banner-item').length);
        $('.promo-banner-item').eq(random).show();   
    });
})(jQuery);

// Set copyright year to copyright elements.
(function ($) {
    $(document).ready(function () {
        var copyrightYear = new Date().getFullYear();
        $('small.copyright-year').html('&copy;' + copyrightYear);
    });
})(jQuery);

//#region brand replacement
function replaceBrandText(classArray, replaceText) {
    try {
        classArray.forEach(function (c) {
            var elems = document.getElementsByTagName('*'), i;
            for (i in elems) {
                if ((' ' + elems[i].className + ' ').indexOf(' ' + c + ' ') > -1) {
                    var bodyHtml = elems[i].innerHTML;
                    Object.keys(replaceText).forEach(function (key) {
                        var re = new RegExp(key, "gi");
                        var replaceTextMatchArray = bodyHtml.match(re);
                        if (replaceTextMatchArray !== null) {
                            replaceTextMatchArray.forEach(function (m) {
                                var replacedText = m.replace(re, replaceText[key]);
                                if (replacedText !== null) {
                                    bodyHtml = bodyHtml.replace(re, replacedText);
                                }
                            });
                        }
                        document.title = document.title.replace(re, replaceText[key]);
                    });
                    elems[i].innerHTML = bodyHtml;
                }
            }
        });
    }
    catch (err) {
        //No error log
    }
}
//#endregion

// iframe resizing event
window.addEventListener('message', function (event) {
  if (event.srcElement.e) {
    var model = ParseJsonString(event.data);
    if (!model || !model.heightSetting || (!model.minHeight && !model.doReset)) {
      return;
    }

    var $targetFrame = $(event.srcElement.e);
    if (model.doReset) {
      var originalHeightData = $targetFrame.data("original-height");
      if (originalHeightData) {
        $targetFrame.css("min-height", originalHeightData);
        $targetFrame.data("original-height", 0);
      }
      return;
    }

    if (model.minHeight > parseInt($targetFrame.css("min-height").replace("px", ""))) {
      $targetFrame.data("original-height", $targetFrame.height());
      $targetFrame.css("min-height", model.minHeight);
    }
  }
});

function ParseJsonString(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}

/* Blog pages -- makes sure RHS aligns with title. JS used since flex CSS is not used for the layout. */
$(document).ready(function () {
    if ($("body").hasClass("blogs")) {
        if ($(".blog-post.title").height() > 60) {
            $(".print-utility .blogTitleBorder").height("34px");
        }
    }
});

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(window).on('resize scroll', function () {
    if ($("body").hasClass("blogs") && $(".load-more-btn a").length !== 0) {
        if ($(".load-more-btn a").isInViewport()) {
            $("body").addClass("active-lm-backtotop");
        }
    }
});

$(document).ready(function () {
    $(".blogs.page-class-insights div.btn-group ul.dropdown-menu li a").click(function (e) {
        var val = $(this).data("id");
        if (val != undefined && val != "") {
            $(this).parent().parent().toggleClass("show");
        }
    });
})